<template>
    <div>
        <color-selector
            v-if="attributeType.searchable_as === 'color_select'"
            class="py-2"
            :items="attributeValuesArray"
            :value="activeValuesArray"
            @change="onAttributeClick($event.attributeValue, $event.value)"
            checkbox
            :small="$vuetify.breakpoint.mdAndUp"
            :readonly="readonly"
        />

        <image-selector
            v-else-if="attributeType.searchable_as === 'image_select'"
            :items="attributeValuesArray"
            :value="activeValuesArray"
            @change="onAttributeClick($event.attributeValue, $event.value)"
            :readonly="readonly"
        />

        <v-list v-else dense class="transparent">
            <v-list-tile
                v-for="(attributeCount, attributeValue) in activeAttributeValues"
                class="attribute-filters-list"
                :key="`attribute-filters-list-${attributeValue}`"
            >
                <v-list-tile-action>
                    <v-checkbox
                        :disabled="readonly"
                        hide-details
                        v-model="models[attributeValue]"
                        @change="onAttributeClick(attributeValue, $event)"
                        :ref="'checkbox' + attributeValue"
                    ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click="onAttributeClick(attributeValue)">
                    <v-list-tile-title>
                        {{attributeValue}}
                    </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <span class="grey--text text--darken-1">({{attributeCount}})</span>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile v-if="isRenderMoreLink || isRenderLessLink" class="more-less-buttons">
                <v-list-tile-action class="text-xs-right d-block">
                    <template v-if="isRenderMoreLink">
                        <a @click.prevent="updateExpandedList()" class="text-underline">
                            {{ 'more' | translation }}
                        </a>
                    </template>
                    <template v-else-if="isRenderLessLink">
                        <a @click.prevent="resetExpandedList()" class="text-underline">
                            {{ 'fewer' | translation }}
                        </a>
                    </template>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </div>
</template>

<style>
    .more-less-buttons .v-list__tile__action {
        width: 100%;
    }
    .more-less-buttons .v-list__tile {
        padding: 0 !important;
    }
    .attribute-filters-list {
        cursor: pointer;
    }
    .attribute-filters-list .v-list__tile   {
        font-size: 16px;
        padding: 0;
    }
    .attribute-filters-list .v-list__tile .image-selector {
        width: 100%;
    }
    .v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
        height: 30px;
    }
    .attribute-filters-list .v-list__tile__action {
        min-width: auto;
    }
</style>

<script>
    import ColorSelector from '@breakmedia/prime-vue-product/src/product-page/Selector/ColorSelector';
    import ImageSelector from '../Selector/ImageSelector';
    import Vue from 'vue';

    export default {
        name: 'AttributeTypeFilter',
        components: {
            ColorSelector,
            ImageSelector,
        },
        props: {
            attributeTypeName: String,
            attributeType: {},
            attributeValues: {},
            readonly: Boolean,
            selectedValues: {},
            initialAmountAttributeValues: {
                default: 3,
            },
            additionalAmountAttributeValues: {
                default: 3,
            },
        },
        data() {
            return {
                additionalAttributeValuesCount: 0,
                models: {},
            };
        },
        computed: {
            amountAttributeValues() {
                return this.additionalAttributeValuesCount + this.initialAmountAttributeValues;
            },
            activeAttributeValues() {
                let result = {};

                let count = 1;
                Object.keys(this.attributeValues).forEach(key => {
                    if (count <= this.amountAttributeValues) {
                        result[key] = this.attributeValues[key];
                        count++;
                    }
                });

                return result;
            },
            attributeValuesArray() {
                let valuesArray = [];

                Object.keys(this.attributeValues).forEach(value => {
                    if (this.attributeType && this.attributeType.Values) {
                        this.attributeType.Values.every(attrValue => {
                            if (attrValue.value === value || attrValue.name === value && attrValue.additions) {
                                valuesArray.push({
                                    text: attrValue.additions,
                                    value: value,
                                    name: attrValue.name,
                                });

                                return false;
                            }

                            return true;
                        });
                    }
                });

                return valuesArray;
            },
            isRenderMoreLink() {
                return this.countValidValues(this.activeAttributeValues) < this.countValidValues(this.attributeValues);
            },
            isRenderLessLink() {
                let result = false;

                let mainValidValues = this.countValidValues(this.attributeValues);
                let currentValidValues = this.countValidValues(this.activeAttributeValues);
                if (
                    currentValidValues >= mainValidValues &&
                    this.initialAmountAttributeValues < Object.keys(this.activeAttributeValues).length
                ) {
                    result = true;
                }

                return result;
            },
            activeValuesArray() {
                let result = [];

                Object.keys(this.models).forEach((value) => {
                    if (this.models[value]) {
                        result.push(value);
                    }
                });

                return result;
            },
        },
        methods: {
            onAttributeClick(attributeValue, value) {
                if (!this.readonly) {
                    Vue.set(this.models, attributeValue, value === undefined ? !this.models[attributeValue] : value);
                    this.$emit('valueSelect', {
                        attributeValue,
                        value: this.models[attributeValue],
                    });
                }
            },
            updateExpandedList() {
                this.additionalAttributeValuesCount += this.additionalAmountAttributeValues;
            },
            resetExpandedList() {
                this.additionalAttributeValuesCount = 0;
            },
            countValidValues(attributeValues) {
                if (Object.keys(attributeValues).length > 0) {
                    let validValueCount = 0;
                    for (let p in attributeValues) {
                        if (attributeValues.hasOwnProperty(p)) {
                            if (p.length > 0) validValueCount++;
                        }
                    }

                    return validValueCount;
                }

                return 0;
            },
        },
        watch: {
            selectedValues: {
                immediate: true,
                deep: true,
                once: true,
                handler(values) {
                    Object.keys(this.attributeValues).forEach(key => {
                        Vue.set(this.models, key, values && values[key] !== undefined ? values[key] : false);
                    });
                },
            },
        },
    };
</script>